import Cookies from 'js-cookie';

import Notification from '../../components/Notification/Notification';
import responseCodes from '../../constants/responseCodes';
import adminAppUrl from '../../routing/adminApp';
import * as organizationsService from '../../services/organizationsService';
import organizationActionConstants from '../constants/organizationActionConstants';

export const getOrganizations = () => async (dispatch) => {
  dispatch({ type: organizationActionConstants.GET_ORGANIZATIONS });

  const response = await organizationsService.getOrganizations();
  if (response.data.response_code === responseCodes.OK) {
    return dispatch({
      type: organizationActionConstants.GET_ORGANIZATIONS_SUCCESS,
      payload: response.data.payload.organizations,
    });
  }
  dispatch({ type: organizationActionConstants.GET_ORGANIZATIONS_ERROR, payload: response.data.error });
};

export const setCurrentOrganization = (organization) => (dispatch) => {
  dispatch({ type: organizationActionConstants.SET_CURRENT_ORGANIZATION_LOADING });
  dispatch({
    type: organizationActionConstants.SET_CURRENT_ORGANIZATION,
    payload: organization,
  });
};

export function getDropdownValues() {
  return (dispatch) => {
    dispatch({ type: organizationActionConstants.GET_DROPDOWN_VALUES });

    organizationsService.getDropdownValues().then((response) => {
      if (response.data.response_code === responseCodes.OK) {
        dispatch({
          type: organizationActionConstants.GET_DROPDOWN_VALUES_SUCCESS,
          payload: response.data.payload.metadata,
        });
      } else {
        dispatch({ type: organizationActionConstants.GET_DROPDOWN_VALUES_ERROR, payload: response.data.error });
        Notification.error(response.data.error);
      }
    });
  };
}

export const removeCurrentOrg = () => (dispatch) => {
  dispatch({ type: organizationActionConstants.REMOVE_CURRENT_ORGANIZATION });
};
export const setFetchedOrgStatus = () => (dispatch) => {
  dispatch({ type: organizationActionConstants.SET_ORGANIZATION_FETCHED });
};
export const getOrganizationByIdentifier = (organizationIdentifier) => async (dispatch) => {
  dispatch({ type: organizationActionConstants.GET_ORGANIZATION_BY_IDENTIFIER });

  const response = await organizationsService.getOrganizationByIdentifier(organizationIdentifier);
  if (response.data.response_code === responseCodes.OK) {
    return dispatch({
      type: organizationActionConstants.GET_ORGANIZATION_BY_IDENTIFIER_SUCCESS,
      payload: response.data.payload.organization,
    });
  }
  dispatch({ type: organizationActionConstants.GET_ORGANIZATION_BY_IDENTIFIER_ERROR, payload: response.data.error });
};

export const getOrganizationGeneralSignup = (identifier) => async (dispatch) => {
  dispatch({ type: organizationActionConstants.GET_ORGANIZATION_BY_IDENTIFIER });

  const response = await organizationsService.getOrganizationGeneralSignup(identifier);
  if (response.data.response_code === responseCodes.OK) {
    return dispatch({
      type: organizationActionConstants.GET_ORGANIZATION_BY_IDENTIFIER_SUCCESS,
      payload: response.data.payload,
    });
  }
  dispatch({ type: organizationActionConstants.GET_ORGANIZATION_BY_IDENTIFIER_ERROR, payload: response.data.error });
};

export function saveOrganizationDetails(data) {
  return (dispatch) => {
    dispatch({ type: organizationActionConstants.SAVE_ORGANIZATION_DETAILS });

    const service = organizationsService.createOrganization;

    service(data).then((response) => {
      if (response.data.response_code === responseCodes.OK) {
        Cookies.set('currentOrganizationId', response.data.payload.organization.id, { sameSite: 'Lax' });
        Cookies.set('currentOrganizationUuid', response.data.payload.organization.uuid, { sameSite: 'Lax' });
        dispatch({
          type: organizationActionConstants.SAVE_ORGANIZATION_DETAILS_SUCCESS,
          payload: response.data.payload.organization,
        });
        window.location.href = `${adminAppUrl}/dashboard?orgUuid=${response.data.payload.organization.uuid}`;
      } else {
        dispatch({ type: organizationActionConstants.SAVE_ORGANIZATION_DETAILS_ERROR, payload: response.data.error });
        Notification.error(response.data.error);
      }
    });
  };
}
